// Auto-generated by generate-locales.mjs - DO NOT EDIT
/**
 * Map of locale codes to dynamic import functions.
 * Used internally by loadStrings().
 */
export const localeLoaders = {
    'ar': () => import(/* webpackChunkName: "fabric-locale-ar" */ './ar.js'),
    'bg': () => import(/* webpackChunkName: "fabric-locale-bg" */ './bg.js'),
    'ca': () => import(/* webpackChunkName: "fabric-locale-ca" */ './ca.js'),
    'cs': () => import(/* webpackChunkName: "fabric-locale-cs" */ './cs.js'),
    'da': () => import(/* webpackChunkName: "fabric-locale-da" */ './da.js'),
    'de': () => import(/* webpackChunkName: "fabric-locale-de" */ './de.js'),
    'el': () => import(/* webpackChunkName: "fabric-locale-el" */ './el.js'),
    'en': () => import(/* webpackChunkName: "fabric-locale-en" */ './en.js'),
    'en-US': () => import(/* webpackChunkName: "fabric-locale-en-US" */ './en-US.js'),
    'es': () => import(/* webpackChunkName: "fabric-locale-es" */ './es.js'),
    'et': () => import(/* webpackChunkName: "fabric-locale-et" */ './et.js'),
    'eu': () => import(/* webpackChunkName: "fabric-locale-eu" */ './eu.js'),
    'fi': () => import(/* webpackChunkName: "fabric-locale-fi" */ './fi.js'),
    'fr': () => import(/* webpackChunkName: "fabric-locale-fr" */ './fr.js'),
    'gl': () => import(/* webpackChunkName: "fabric-locale-gl" */ './gl.js'),
    'he': () => import(/* webpackChunkName: "fabric-locale-he" */ './he.js'),
    'hi': () => import(/* webpackChunkName: "fabric-locale-hi" */ './hi.js'),
    'hr': () => import(/* webpackChunkName: "fabric-locale-hr" */ './hr.js'),
    'hu': () => import(/* webpackChunkName: "fabric-locale-hu" */ './hu.js'),
    'id': () => import(/* webpackChunkName: "fabric-locale-id" */ './id.js'),
    'it': () => import(/* webpackChunkName: "fabric-locale-it" */ './it.js'),
    'ja': () => import(/* webpackChunkName: "fabric-locale-ja" */ './ja.js'),
    'kk': () => import(/* webpackChunkName: "fabric-locale-kk" */ './kk.js'),
    'ko': () => import(/* webpackChunkName: "fabric-locale-ko" */ './ko.js'),
    'lt': () => import(/* webpackChunkName: "fabric-locale-lt" */ './lt.js'),
    'lv': () => import(/* webpackChunkName: "fabric-locale-lv" */ './lv.js'),
    'ms': () => import(/* webpackChunkName: "fabric-locale-ms" */ './ms.js'),
    'nl': () => import(/* webpackChunkName: "fabric-locale-nl" */ './nl.js'),
    'no': () => import(/* webpackChunkName: "fabric-locale-no" */ './no.js'),
    'pl': () => import(/* webpackChunkName: "fabric-locale-pl" */ './pl.js'),
    'pt': () => import(/* webpackChunkName: "fabric-locale-pt" */ './pt.js'),
    'pt-BR': () => import(/* webpackChunkName: "fabric-locale-pt-BR" */ './pt-BR.js'),
    'pt-PT': () => import(/* webpackChunkName: "fabric-locale-pt-PT" */ './pt-PT.js'),
    'ro': () => import(/* webpackChunkName: "fabric-locale-ro" */ './ro.js'),
    'ru': () => import(/* webpackChunkName: "fabric-locale-ru" */ './ru.js'),
    'sk': () => import(/* webpackChunkName: "fabric-locale-sk" */ './sk.js'),
    'sl': () => import(/* webpackChunkName: "fabric-locale-sl" */ './sl.js'),
    'sr-Cyrl': () => import(/* webpackChunkName: "fabric-locale-sr-Cyrl" */ './sr-Cyrl.js'),
    'sr-Cyrl-RS': () => import(/* webpackChunkName: "fabric-locale-sr-Cyrl-RS" */ './sr-Cyrl-RS.js'),
    'sr-Latn': () => import(/* webpackChunkName: "fabric-locale-sr-Latn" */ './sr-Latn.js'),
    'sr-Latn-RS': () => import(/* webpackChunkName: "fabric-locale-sr-Latn-RS" */ './sr-Latn-RS.js'),
    'sv': () => import(/* webpackChunkName: "fabric-locale-sv" */ './sv.js'),
    'th': () => import(/* webpackChunkName: "fabric-locale-th" */ './th.js'),
    'tr': () => import(/* webpackChunkName: "fabric-locale-tr" */ './tr.js'),
    'uk': () => import(/* webpackChunkName: "fabric-locale-uk" */ './uk.js'),
    'vi': () => import(/* webpackChunkName: "fabric-locale-vi" */ './vi.js'),
    'zh-Hans': () => import(/* webpackChunkName: "fabric-locale-zh-Hans" */ './zh-Hans.js'),
    'zh-Hant': () => import(/* webpackChunkName: "fabric-locale-zh-Hant" */ './zh-Hant.js'),
    'zh-cn': () => import(/* webpackChunkName: "fabric-locale-zh-cn" */ './zh-cn.js'),
    'zh-tw': () => import(/* webpackChunkName: "fabric-locale-zh-tw" */ './zh-tw.js'),
};
/**
 * List of all available locale codes.
 */
export const availableLocales = Object.keys(localeLoaders);
